export const updateUserDetails = (data) => {
  return {
    type: "UPDATE_USER_DETAILS",
    data
  };
}
export const updateQuestionAnswers = (questionsWithAnswers) => {
  return {
    type: "UPDATE_QUESTION_ANSWERS",
    questionsWithAnswers
  };
}
